function Services() {
    return (
      <section id="services" className="section">
        <h2>Services</h2>
        <div className="grid">
          <div className="card">💪 Strength Training</div>
          <div className="card">🏃 Cardio</div>
          <div className="card">🧘 Yoga</div>
        </div>
      </section>
    );
  }
  
  export default Services;